import DeleteAbsoluteButton from '@/components/UiElements/DeleteAbsoluteButton'

type UserRelationBadgeProps = {
    title: string
    description?: string
    onRemove: () => void
    disabled?: boolean
}

const UserRelationBadge = ({
    title,
    description,
    onRemove,
    disabled = false,
}: UserRelationBadgeProps) => (
    <div className="relative flex h-[64px] min-w-[180px] max-w-[280px] flex-col justify-center rounded-md bg-gray-50 py-sm pl-md pr-[48px]">
        <p className="truncate text-title-md capitalize text-gray-900" title={title}>
            {title}
        </p>
        {description && (
            <p className="mt-xs truncate text-text-sm text-gray-400" title={description}>
                {description}
            </p>
        )}
        <DeleteAbsoluteButton
            onClick={disabled ? undefined : onRemove}
            className={disabled ? 'pointer-events-none opacity-50' : ''}
        />
    </div>
)

export default UserRelationBadge
